import ForecastDay from "./ForecastDay";

export default function Forecast(props) {
  function formatDay(timestamp) {
    const date = new Date(timestamp * 1000);

    return date.toLocaleDateString("en-AU", {
      weekday: "long",
    });
  }

  function formatForecastDate(timestamp) {
    const date = new Date(timestamp * 1000);

    return date.toLocaleDateString("en-AU", {
      day: "numeric",
      month: "short",
    });
  }

  function getWeatherIcon(icon) {
    if (icon === "clear-sky-day") {
      return "CLEAR_DAY";
    }

    if (icon === "clear-sky-night") {
      return "CLEAR_NIGHT";
    }

    if (
      icon === "few-clouds-day" ||
      icon === "scattered-clouds-day"
    ) {
      return "PARTLY_CLOUDY_DAY";
    }

    if (
      icon === "few-clouds-night" ||
      icon === "scattered-clouds-night"
    ) {
      return "PARTLY_CLOUDY_NIGHT";
    }

    if (
      icon === "broken-clouds-day" ||
      icon === "broken-clouds-night"
    ) {
      return "CLOUDY";
    }

    if (
      icon.includes("rain") ||
      icon.includes("thunderstorm")
    ) {
      return "RAIN";
    }

    if (icon.includes("snow")) {
      return "SNOW";
    }

    if (icon.includes("mist")) {
      return "FOG";
    }

    return "PARTLY_CLOUDY_DAY";
  }

  return (
    <section className="forecast">
      <h2>5-Day Forecast</h2>

      <div className="forecast-container">
        {props.data.map(function (day) {
          return (
            <ForecastDay
              key={day.time}
              day={formatDay(day.time)}
              date={formatForecastDate(day.time)}
              description={day.condition.description}
              icon={getWeatherIcon(day.condition.icon)}
              high={day.temperature.maximum}
              low={day.temperature.minimum}
              wind={Math.round(day.wind.speed * 3.6)}
              humidity={day.temperature.humidity}
              unit={props.unit}
              darkMode={props.darkMode}
            />
          );
        })}
      </div>
    </section>
  );
}